import { z } from 'zod';
import { KpiObraSchema } from './avance.schema.js';
export const ObraCabeceraSchema = z.object({
    worksNo: z.string(),
    displayName: z.string().nullable(),
    areaCosteo: z.string().nullable(),
    status: z.string().nullable(),
    startingDate: z.string().nullable(),
    endingDate: z.string().nullable(),
    projectManager: z.string().nullable(),
    areaProrrateadaM2: z.number().nullable(),
});
export const PuntoAvanceMensualSchema = z.object({
    anio: z.number().int(),
    mes: z.number().int().min(1).max(12),
    pctAvance: z.number(),
});
export const ProductoEnObraSchema = z.object({
    llaveCodigo: z.string().nullable(),
    consolidatedCode: z.string().nullable(),
    description: z.string().nullable(),
    itemCategoryCode: z.string().nullable(),
    unidadMedida: z.string().nullable(),
    totalQuantity: z.number(),
    totalCostoLcy: z.number(),
    costoDirecto: z.number(),
    costoIndirecto: z.number(),
});
export const CuentaEnObraSchema = z.object({
    llaveCodigo: z.string().nullable(),
    codigo: z.string().nullable(),
    description: z.string().nullable(),
    totalCostoLcy: z.number(),
    rowCount: z.number().int(),
});
export const PartidaEnObraSchema = z.object({
    taskNo: z.string().nullable(),
    tareaDisplay: z.string().nullable(),
    totalCostoLcy: z.number(),
    costoDirecto: z.number(),
    costoIndirecto: z.number(),
    totalQuantity: z.number(),
});
export const ObraDetalleSchema = z.object({
    cabecera: ObraCabeceraSchema,
    kpi: KpiObraSchema.nullable(),
    avanceHistorico: z.array(PuntoAvanceMensualSchema),
    productos: z.array(ProductoEnObraSchema),
    cuentas: z.array(CuentaEnObraSchema),
    partidas: z.array(PartidaEnObraSchema),
});
//# sourceMappingURL=detalle.schema.js.map